<template>
  <div class="axios-error">
    <p>
      Whoops! Looks like our llamas are having a tough time connecting to our
      servers.
    </p>
    <p>Please refresh your browser, or try again later.</p>
  </div>
</template>
